import { externalRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  detectFaces(key, params) {
    const url = externalRoutes.googleVisionPath(key);
    return FetchHelpers.post(url, params);
  },
};
